import { render } from "./selectphones.vue?vue&type=template&id=debf801e"
import script from "./selectphones.vue?vue&type=script&lang=js"
export * from "./selectphones.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__